import { Text } from '@/components'
import clsx from 'clsx'
import { HelpCircle } from 'react-feather'

export type RewardRowProps = {
  onClick?: () => void
  icon: JSX.Element
  label: string
  label2: JSX.Element
  description: string
  /** Shows a "?" after the label for rows that open a detail modal */
  showInfoIcon?: boolean
}

export const RewardRow = ({ ...props }: RewardRowProps) => {
  const { icon, label, label2, description, onClick, showInfoIcon } = props

  return (
    <div
      className={clsx('w-full flex flex-row items-start justify-between py-6', {
        'cursor-pointer': onClick,
      })}
      onClick={onClick}
    >
      {icon}
      <div className="flex flex-col grow items-start px-4 gap-1">
        <div className="flex flex-row items-center gap-1.5">
          <Text className="text-sm font-semibold text-gray-900">{label}</Text>
          {showInfoIcon && (
            <HelpCircle
              size={16}
              className="text-gray-900 shrink-0"
              aria-hidden
            />
          )}
        </div>
        <Text className="text-sm font-normal text-gray-500">{description}</Text>
      </div>
      {label2}
    </div>
  )
}
